/// <reference path="../../ng-services/chat.service.ts"/>

import { LightboxItem } from '../../ng-services/lightbox.service';

(function () {
    class LightboxImageComponent {
        static $inject = ['$timeout'];

        public item!: LightboxItem;
        public loaded = false;

        constructor(private $timeout: ng.ITimeoutService) {}

        $onInit() {
            const image = new Image();
            image.onload = () =>
                this.$timeout(() => {
                    this.loaded = true;
                });
            if (this.item.preview_url) {
                image.src = this.item.preview_url;
            }
        }
    }

    angular.module('tradersyard').component('tyLightboxImage', {
        template: `
      <div class="lightbox_image">
        <ty-loading-spinner ng-if="!$ctrl.loaded"/>
        <img ng-if="$ctrl.loaded" ng-src="{{$ctrl.item.preview_url}}">
</div>
    `,
        controller: LightboxImageComponent,
        bindings: {
            item: '<',
        },
    });
})();
